/* PawsOn 2026 — guide cluster.

   Only the glossary filter needs script. Every row is rendered by Liquid and
   filtering sets the hidden attribute on the ones that do not match, so the
   whole table is in the HTML for a reader with no JavaScript and for a
   crawler. Rebuilding the table body here would take the most valuable thing
   on the page away from both. */

(function () {
  'use strict';

  function initGlossary(root) {
    var filters = root.querySelector('[data-pw-gloss-filters]');
    if (!filters) return;

    var chips = Array.prototype.slice.call(filters.querySelectorAll('[data-pw-band]'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('.pw-gloss__row'));
    if (!chips.length || !rows.length) return;

    function apply(band) {
      rows.forEach(function (row) {
        row.hidden = band !== 'All' && row.dataset.pwBand !== band;
      });
      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', chip.dataset.pwBand === band ? 'true' : 'false');
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        apply(chip.dataset.pwBand);
      });
    });
  }

  function boot() {
    document.querySelectorAll('.pw-gloss-section').forEach(initGlossary);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
